import Vue from "vue";
import "./plugins/vuetify";
import "./plugins/vee-validate";
import "./plugins/fragment";
import "./plugins/viewer";
import "./plugins/timers";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import moment from "moment";

import "./global.style.css";

Vue.config.productionTip = false;

Vue.filter("date", function(value) {
  if (typeof value === "number") {
    return moment.unix(value / 1000).format("DD/MM/YYYY");
  }
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY");
  }
});

Vue.filter("fullDate", function(value) {
  if (typeof value === "number") {
    return moment.unix(value / 1000).format("DD/MM/YYYY à HH:mm");
  }
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY à HH:mm");
  }
});

Vue.filter("shortDate", function(value) {
  if (typeof value === "number") {
    return moment.unix(value / 1000).format("DD/MM");
  }
  if (value) {
    return moment(String(value)).format("DD/MM");
  }
});

Vue.filter("time", function(value) {
  const mins = (value / 60).toFixed(0);
  const minsLeft = mins % 60;
  const hours = Math.floor(mins / 60);
  if (hours >= 2) {
    return `${Math.floor(mins / 60)}h${minsLeft < 10 ? "0" : ""}${minsLeft}`;
  } else {
    return `${mins < 10 ? "0" : ""}${mins}min`;
  }
});

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");
